import React from 'react'
import { Tooltip } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { CS_LANGUAGES } from '../../../../../../../constants/languages'

const FileUploadTooltip = () => {
    return (
        <Tooltip
            title={
                <div>
                    <div style={{ marginBottom: '8px' }}>
                        <strong>Upload requirements:</strong>
                    </div>
                    <ul style={{ margin: 0, paddingLeft: '16px' }}>
                        <li>Must be a ZIP file</li>
                        <li>Should contain files in only one format (same extension)</li>
                        <li>Supported extensions: {CS_LANGUAGES.map(ext => `.${ext}`).join(', ')}</li>
                        <li>Files should have valid content specific to the language</li>
                    </ul>
                </div>
            }
        >
            <QuestionCircleOutlined />
        </Tooltip>
    )
}

export default FileUploadTooltip
